webpackJsonp([35783957827783],{

/***/ 189:
/***/ (function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 22:
/***/ (function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 190:
/***/ (function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(22);
	
	exports.__esModule = true;
	exports.OutboundLink = OutboundLink;
	exports.trackCustomEvent = trackCustomEvent;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(189));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(190));
	
	var _react = _interopRequireDefault(__webpack_require__(3));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(7));
	
	var createFunctionWithTimeout = function createFunctionWithTimeout(callback, opt_timeout) {
	  if (opt_timeout === void 0) {
	    opt_timeout = 1000;
	  }
	
	  var called = false;
	
	  var raceCallback = function raceCallback() {
	    if (!called) {
	      called = true;
	      callback();
	    }
	  };
	
	  setTimeout(raceCallback, opt_timeout);
	  return raceCallback;
	};
	
	function OutboundLink(props) {
	  var eventCategory = props.eventCategory,
	      eventAction = props.eventAction,
	      eventLabel = props.eventLabel,
	      eventValue = props.eventValue,
	      rest = (0, _objectWithoutPropertiesLoose2.default)(props, ["eventCategory", "eventAction", "eventLabel", "eventValue"]);
	  return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({}, rest, {
	    onClick: function onClick(e) {
	      if (typeof props.onClick === "function") {
	        props.onClick(e);
	      }
	
	      var redirect = true;
	
	      if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey || e.defaultPrevented) {
	        redirect = false;
	      }
	
	      if (props.target && props.target.toLowerCase() !== "_self") {
	        redirect = false;
	      }
	
	      if (window.ga) {
	        window.ga("send", "event", {
	          eventCategory: eventCategory || "Outbound Link",
	          eventAction: eventAction || "click",
	          eventLabel: eventLabel || props.href,
	          eventValue: eventValue,
	          transport: redirect ? "beacon" : "",
	          hitCallback: function hitCallback() {
	            if (redirect) {
	              document.location = props.href;
	            }
	          }
	        });
	      } else {
	        if (redirect) {
	          document.location = props.href;
	        }
	      }
	
	      return false;
	    }
	  }));
	}
	
	OutboundLink.propTypes = {
	  href: _propTypes.default.string,
	  target: _propTypes.default.string,
	  eventCategory: _propTypes.default.string,
	  eventAction: _propTypes.default.string,
	  eventLabel: _propTypes.default.string,
	  eventValue: _propTypes.default.number,
	  onClick: _propTypes.default.func
	};
	/**
	 * This allows the user to create custom events within their Gatsby projects.
	 *
	 * @param {import('gatsby-plugin-google-analytics').CustomEventArgs} args
	 * @see https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#events
	 */
	
	function trackCustomEvent(_ref) {
	  var category = _ref.category,
	      action = _ref.action,
	      label = _ref.label,
	      value = _ref.value,
	      _ref$nonInteraction = _ref.nonInteraction,
	      nonInteraction = _ref$nonInteraction === void 0 ? false : _ref$nonInteraction,
	      transport = _ref.transport,
	      hitCallback = _ref.hitCallback,
	      _ref$callbackTimeout = _ref.callbackTimeout,
	      callbackTimeout = _ref$callbackTimeout === void 0 ? 1000 : _ref$callbackTimeout;
	
	  if (typeof window !== "undefined" && window.ga) {
	    var trackingEventOptions = {
	      eventCategory: category,
	      eventAction: action,
	      eventLabel: label,
	      eventValue: value,
	      nonInteraction: nonInteraction,
	      transport: transport
	    };
	
	    if (hitCallback && typeof hitCallback === "function") {
	      trackingEventOptions.hitCallback = createFunctionWithTimeout(hitCallback, callbackTimeout);
	    }
	
	    window.ga("send", "event", trackingEventOptions);
	  }
	}

/***/ }),

/***/ 101:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	    if (condition) {
	        return;
	    }
	    if (isProduction) {
	        throw new Error(prefix);
	    }
	    var provided = typeof message === 'function' ? message() : message;
	    var value = provided ? prefix + ": " + provided : prefix;
	    throw new Error(value);
	}
	
	module.exports = invariant;


/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/confetti@2x.601016d5.png";

/***/ }),

/***/ 443:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 444:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAAAXNSR0IArs4c6QAABRZJREFUeAHtXM1uHEUQntkL74BA2Rw4cLIlHiBIlhMpJyPlAbgEcSOciB0nh/woySnJGSWPQIyEECRC4g3snLiAsxZ+CYS0k+/z9q4mvZPt/robYXeqpPJMT1fX1/Vtz+50uafbZkC6rvsAl7egl6Fr0DGUMoG+gv4M3Wvb9h8ci0kVuAhiEzqBhoQ2F0uxB19nHxdBXA+x5tVPUd7JJbEKXBLhkaMUt1NJrAIXQfD24WhKFbbdVElkG+iZxm0RAH8w/oR+pBLg2f+N8iexPyy14I4Q9BVoLnnk8mPni+cxUgUuCeSjSilRfCm2of4pvhTbIC4J/CxkJdQrvhTbUBcUX4ptEJcEfhiyEuoVX4ptqAuKL8U2iEsCTTIYIIHHGe39poovxdbH8cuKL8XWx/HLxyRw37+aUVZ8KbahLim+FNsgLgn8KWQl1Cu+FNtQFxRfim0Ylw+00ENortAHH8qjhLbQOnARyAY0d0q1EcVcz6gqXASjZmLQZCHf9XiRTuGhHlwEo2ZkOGpvSIwNGFeFi2BiE5t/0XaAj6RLZxW3HYoWwfgp/XOwo+0EOk/p/4DMy78oF5P3DbcYcebIGDAGjAFjwBgwBowBY8AYMAbeMwYGp3LkoGtufonDBczg1nGkUg5QA2332ub2j7NL5f4OTOXGzvsEx/kU8lStClsisGt2t5pm9AgdHkNXyaRppt+2zd29VUaxdUwmwPZ7KOfdq+QIlV9hHv5ilVFsXS7uW/+V65pbj0Hec4CPIzoAm9FzjFSSnSUI4jockJAQecShzS9os8NCjpTAXYzAGXnNN4kdeoJb+lpKW0fEvZS2aLODkXg/pW0p3BMC3W3LkZch0y/U2xlB8Lb9Fbr4IMUOdLC/BBJfKu1K4rpbuMWtmysn35vRThAEc47PoKnkEYttnzpfLAelNO5o9mvbxnz3hDo3no3kkNmi/grOzvyqMIzA9vNFSNknoy3BRdFVUv8XLgjs1gXwkOlayKBXX3SVVM9v6LQoLkegEnSoc8qHUXSVVKhjvfqiuO5HpOfeTiUGeAtzilRIJF9FV0kJARTF5S18IIAHTCVf+wFnSrXiS7EN9WGfI/D3kFV8/XQv3raOVWFuJnJzgpGY+SzYHbXNnXEsge6B9g/Yn49t8w6717j+KWYjUe/tlcbFCKR012bHnL+aDxfwVYJnoLLt1VjyiFMa94RAN4d9khEIkgl6WgvB/AbMnKzKtvMhdb0krhuB+GRm2ZQUEpMzMYwawTzAQV3hxZG3i7YP6SNFSuEuTeRn81kmF0Lfid0Rb/2UkTcUML6bYhOqh2j/NQiQMjBDmLyWi7tE4BzIpbi2ALEOMt1shc95fFSZIqWv37Jz3+86ui94YC5e9D6Hc/ZxAuXzKl/0rmZVGGIxMQaMAWPAGDAGjAFjwBgwBowBYyCBgcGp3MCUaux8T3CcT6lO1Sop17+kQ9F4ObmG2t5ZIMGT8F5haKC+OcmXDXPyeScjpgpcEgFNFds7C8zlvnDNfJ4kwLS9s3qM2d5ZPTJSTm3vrBTWvDbKiivF1oNZKiq+FNslIO/CZf5TqehqJQ9gVbEKXBJYdLXSKsa8uipwF//W9IKzYiQDJLDoaqVIXJpVgUsCi65WEgisApcElt1LKp7BOnAxG6hnD6uID+8/iRdObe8skCAIp71v7xWGC2ompo9ne2dx9IMRNSNje2f5XxsgMTahantngbzYlH7Vq6QwaPjeXtKqsDcgL1gPa5heVQAAAABJRU5ErkJggg=="

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/grid@2x.50932b26.png";

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _confetti2x = __webpack_require__(442);
	
	var _confetti2x2 = _interopRequireDefault(_confetti2x);
	
	var _logo2x = __webpack_require__(446);
	
	var _logo2x2 = _interopRequireDefault(_logo2x);
	
	var _grid2x = __webpack_require__(445);
	
	var _grid2x2 = _interopRequireDefault(_grid2x);
	
	var _dots2x = __webpack_require__(444);
	
	var _dots2x2 = _interopRequireDefault(_dots2x);
	
	var _symbols2x = __webpack_require__(452);
	
	var _symbols2x2 = _interopRequireDefault(_symbols2x);
	
	var _symbol2x = __webpack_require__(451);
	
	var _symbol2x2 = _interopRequireDefault(_symbol2x);
	
	var _settings2x = __webpack_require__(448);
	
	var _settings2x2 = _interopRequireDefault(_settings2x);
	
	var _setting2x = __webpack_require__(447);
	
	var _setting2x2 = _interopRequireDefault(_setting2x);
	
	var _shapes2x = __webpack_require__(450);
	
	var _shapes2x2 = _interopRequireDefault(_shapes2x);
	
	var _shapeIcon2x = __webpack_require__(449);
	
	var _shapeIcon2x2 = _interopRequireDefault(_shapeIcon2x);
	
	var _depth2x = __webpack_require__(443);
	
	var _depth2x2 = _interopRequireDefault(_depth2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  confetti: _confetti2x2.default,
	  logo: _logo2x2.default,
	  grid: _grid2x2.default,
	  dots: _dots2x2.default,
	  symbolOverview: _symbols2x2.default,
	  symbol: _symbol2x2.default,
	  settings: _settings2x2.default,
	  setting: _setting2x2.default,
	  shapes: _shapes2x2.default,
	  shapeIcon: _shapeIcon2x2.default,
	  depth: _depth2x2.default
	};
	module.exports = exports['default'];

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo@2x.c831fd91.png";

/***/ }),

/***/ 447:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAAAXNSR0IArs4c6QAABhFJREFUeAHtnE1oHVUUx2cSxGy0qahkoZKqSJBWExcS20oSbP3AhRF3iogUxY20iyou1D5bUaSKdu2qFFcqpuBHoWIb/Gp10ypoqNYGESlVMLixFZrx939vJrw8J8l8nfvezMuBkzsz797zP+c/58zcuS/zfK8kEgTBIK5uQYfQq9GrwvbKcJvG+6NFz7E/gx7yff832u4SSFuP7kVPo3nlRwzI1vpKs0iAA+gz6EnUSmR7JzpQGTIJpg99Ci0i2zCTSIT1JHpJqYkkgNvQL9F2ibBvLh2JOO2j29ELaLtFPjxdGhJx9gr043azFoP/LscuS0qkn7Rjkf1wUNOQT9ENRdot0NZ32NrK1EfToGXFOYGQdy0efYbeuKxn7f/wJ1zYAom/LueKUwIh73Kc+QLt1Mxr5UqZOAqJ/7R+EO33RBvWLeQJ6320LOSJklvQA6Hv2v+fOCMQ5FdQPYqVTR7CYfkeK05KmDN4P+gfxnpQnoOTlPLBVnfNCYS86wDVtWRNK3jJ9ufwdwQSZ5v9dlHCuwEsO3nirB+taaNZTDOQ7JsATFOWKsntZOG3UUDWGbgrAqpQu7c5FjMCyb5xgMaawSqyPRbGVg/HjECs1ypCWFwYC7GZXAM5Q+tAPY2a2I+LyPGxALwBroXnrDLwsQqTp3OlxHhYG1YEjst4xWVS8RVeYpRvH3b/QtVWWc4T3FqLDBzFcNXJU2IoxlErAgXQDWJC4FA3MBfGOGSRgd1E4KAFgdX5snrlUjIhsBtuIBG1fRbTGN3eL40QKt5esCjhinO2ODwLArVy2y0yZ0GgSrhb5LwFgWe7hT3iPGtB4EwXETizSmC+s21C4LF8PpVq9DGLeaAm0qvLWVnzgGVu3YWPZx1fonHHFavFNVAcHCoREVldrcdYeAnLG1alr6f5GTWxL4w2i75UuoEMPGOSgRj+BYDDbQ7SEv6wyBOACYGh569aRtBm2wuxmZYYpXyUQMfaHGzR8NNk33hk1JrAOwD6KgKrSLsRAr+OYrEsYS8E2h+BVaDd30ye4jHNQAFQxnqb8hS6VvslFj0c3ASBfzbHYJqBAgoBH28GLen2o63kKQ5zAgUCsP63eJ+2SyqvEcNHcb6bl3AESinrZGn2vjU6VpJWb1TdA4Hzcf46I1DgkKgXbT5H9f5FGeR7nNwMeX8v5ayTEo7AQ0fuY1+vUXW66FH07uXIUwBOCRQgDv1OsxnVqw+dKt/g2CZ8XfHrCecEijEc01uQd6KfaL/D5D38uSv0cUXXVrwGBl5t0PPmH+AKxj8U+npXYji0eoJjcxybIpEP+l5tNjyeuOGaKPzn0D1ob+KBNh3/xeyzEJdqtrAkgYH3/Djk7EJpk4iee4OXfO9l2nQCkXrd/m10Y7qRhfXW4+YTkPdDWouxJRx4L7xJVh1JTp5gRXTPkcbYdG7IcXQTo7ahs+lG5+otrG3CzkKekBdlIOXa73kXP0hHnMy0irKx90HKmhJPL2TkI4zaiQ6nH51oxEl6vQFpBxL1XqZTSwYWQZ7QlI2ylU0I7B10hNF6t/h1VFOKvCIbsrUB28NFkCeHFjIw8F58i/3tOlig7PO93TuKsEdWXoOde9EhNPrpJ/38U6Rs1n/6SQ/7usvrZ6DUzqBmP/1UJ7Bxw9A1z0LmJ7LcWCw8sbAZlrDutlZiadvK5+R2/XCedyb5kCw9e9ZlmSdmQXI9hgy8OGkP6gLDPoo4BJWwAwKdYMTFZ34MAv015ihOMOyjiENQBg7HfVDwMRcYBbuczJwIXJUcDEBgoMcaY3GBYRzCEuaVgXNLfFbkYRcYRfqb2JYInErcO3tHFxjZvcsxEgJ7HQTnAiMHCzmG9jSeEILpHDZWGBpMV/UpRIGrhJGgVm9M/vTuMDHbIUbrBIarJam+C0joP8tZtRMJ+5ay28J6oLxnOf4oTyZjxUSi0t0zXoytzrUSlnDkYO8kNBZwPZQN2aq+LMrAKNycq9OFrUJH/nRy25KBDVcby/DzE+myUVnXM1LUEn4nk9bsW2wGNndoLLjW1/NUkv1cI29tfF5/PJtje0pzySpPVZr5aN3+D3niIA49IOKhAAAAAElFTkSuQmCC"

/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/settings@2x.ad10c4d2.png";

/***/ }),

/***/ 449:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAAAXNSR0IArs4c6QAABFFJREFUeAHtnD1y2zAQhUVPKjdRThCldRM36XME+wTiEXyC2DpB3Dit5TqNz5EUsYu4dXwCy0XSKu/JgIamCJokgAVIcGc2AH+AxX5aPFEcT7JJQ1uv14e4dQ5nO1UtmskNfKXaqyzLeDwaCQDaFH4Kf4Q3Nd57mjxBQDiC38O72j0GHiUJEol/7UqtYlxa1QgAlxUQbE9dJlGJoHRuS6pm/NmgISJxap5vG5wmZqwKUJui+QWfwX3aHzzmfPAZQHruPRXwBO1MIPgMH9aZQByxELoCHxGRVShhK1ThO4lAEjH2UBGfEUgKHnPiw/khO0MwbuGjAInkAWJ6CUmAIaohRExvAN96mbl+0hAx61fU8WoGPVp3HGs1DF8kmy8wq0kweD35EmT9et36MUYfj21LAgR423KMi9tDxHSx7p05CHC1c9b/iRAxvWRFgDdeZq6fNETM+hV1vEqAy45jbYaFiGmzXuPYPXwZshqejHe4v/CkYrqfOcCMrEDa+XMj8q9kLO8J6ZcJU0RiJb73HPEB1TdzGSOK50AktUJSJy4TM8wlEcMQ2s9pvYUngHiNEAs/YTazLlQMjyHkp94CZGgkeIbmin3HdqXmdjxt+OleAORykGiOxmUlLtScnH5wtgOQGapqOUb3wSJjjj1Wc1lME/fQSoBcMhK/hs/QZTW2eU7kvQuO5RzoD9qyptmp1/A57j+ET+Ef4bRb+Ap+A18CGlsxC/0Y0xigGJGWgUIDNG7hlnkke/sI0PKjHwGOAC0JWA4fK3AEaEnAcvhYgSNASwKWw8cK7CNA/CzM6ZZrj2L4G+lVANwBYl4wLvo/8Nv5TnoNLuOJbmEA28fiv8PZbvrqnMucROcSBYjMvsFZgdrY57nemhhAVFoOSvMKUnN1reJS/KdEAAIQK22jewYkF+oew+WETwPMPvw3/DXjPdTF0YoEAGX5GrnC9WVxbPJ9gOHzXlvLkwdHAKB2AP/blp4aU/ymTo8nIDTVPRPftPUQVNrongniMr3Se966XXTPBDFPCiIodNU9E0BqaBp6iERtdc8EMQ09RPYudM8EcTnorYysXeqeCeIw9RDZutY9E8Ao9dDqb2OQKX+7/oRLCT1fvn7CS9h/aKMw27cx5fd7vpPiB9Xr94dbQKg+Cd0zbed8u5DAnU5bGFmxErh1uYVDGLcwt/JdiODFmK0BBtC94nqLfcILroddNJAaJPWlUQRW7vdPDwPrXpR62HgLR6B75QrUx0H1sBHAiHRPQyu3wfSwqQbGontlcPo4Xj2MVPei0cPaLRyx7unKK7fiemgE2APdK8PTx6J6WKeBseueBlZuRfWwEiB1D6uq+juW8mJjPZ6rHLyvb2cLIzA/wZC/c10lLaKHLwAC3r6CR4hDMO96WN7CfdU904ftXQ+3AJVm9Fn3TBDnKjfTdavzmy2MAEPRPRMMb3rI/z9waLpnguhFD7mFh6Z7JoBe9PA/qsMVQhKR5ocAAAAASUVORK5CYII="

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/shapes@2x.67267fe0.png";

/***/ }),

/***/ 451:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/symbols@2x.25a73919.png";

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(65);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyPluginGoogleAnalytics = __webpack_require__(313);
	
	var _home = __webpack_require__(200);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'main',
	    { className: 'home' },
	    _react2.default.createElement(
	      'header',
	      { className: 'header padding-xxl' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container-md' },
	        _react2.default.createElement(
	          'div',
	          { className: 'grid yg center text-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12' },
	            _react2.default.createElement('img', { src: _home.logo, className: 'logo margin-xs-bottom', alt: 'Confetti logo' }),
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Confetti'
	            ),
	            _react2.default.createElement(
	              'h4',
	              null,
	              'for Adobe XD'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'streamer center margin-m-bottom' },
	              'Generate gorgeous confetti patterns in 1 click within Adobe XD.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'buttons margin-xl-bottom' },
	              _react2.default.createElement(
	                _gatsbyPluginGoogleAnalytics.OutboundLink,
	                {
	                  className: 'btn primary lg',
	                  href: 'https://xd.adobelanding.com/en/xd-plugin-download/?name=d2f4d13f'
	                },
	                _react2.default.createElement(
	                  'svg',
	                  { width: '32', height: '32', viewBox: '0 0 32 32' },
	                  _react2.default.createElement(
	                    'g',
	                    { fill: 'none', fillRule: 'evenodd' },
	                    _react2.default.createElement('circle', { cx: '16', cy: '16', r: '16', fill: '#FFFFFF', fillRule: 'nonzero' }),
	                    _react2.default.createElement('path', { fill: '#FF007E', fillRule: 'nonzero', d: 'M14.4746456,18.3952784 L14.4746456,10.032875 C14.4746456,9.1862915 15.1609371,8.5 16.0075206,8.5 C16.8541041,8.5 17.5403956,9.1862915 17.5403956,10.032875 L17.5403956,18.3802372 L19.429711,16.4909218 C20.0154974,15.9051354 20.9652449,15.9051354 21.5510313,16.4909218 C22.1368178,17.0767083 22.1368178,18.0264557 21.5510313,18.6122422 L17.1689139,22.9943595 C17.1020392,23.0612343 17.0304209,23.1204745 16.9551422,23.1720801 C16.6943434,23.3774655 16.3652417,23.5 16.0075206,23.5 C15.6899075,23.5 15.3948559,23.4034025 15.150142,23.2379836 C15.035958,23.172972 14.9284904,23.0917639 14.8310861,22.9943595 L10.4489687,18.6122422 C9.86318225,18.0264557 9.86318225,17.0767083 10.4489687,16.4909218 C11.0347551,15.9051354 11.9845026,15.9051354 12.570289,16.4909218 L14.4746456,18.3952784 Z' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'Install Now',
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'v3.0.2'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'video-container' },
	          _react2.default.createElement('iframe', { src: 'https://www.youtube-nocookie.com/embed/l1jJIG9xCzQ?controls=0', frameBorder: '0', allowFullScreen: true })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'features padding-xxl-top' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container-md' },
	        _react2.default.createElement(
	          'div',
	          { className: 'grid yg settings-feature padding-xxl align-middle' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-6 text-content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'feature-icon margin-s-bottom' },
	              _react2.default.createElement('img', { src: _home.shapeIcon, alt: 'Shapes illustration' })
	            ),
	            _react2.default.createElement(
	              'h2',
	              { className: 'light' },
	              'Tweak your settings'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'light narrow' },
	              'Everything about how your confetti looks is customizable. What to you want to randomize? Opacity, rotation, scale?'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-6' },
	            _react2.default.createElement('img', { src: _home.settings, className: 'feature-illu settings-image', alt: 'Settings overview' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'grid yg shapes-feature padding-xxl padding-xxxl-bottom align-middle' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-6' },
	            _react2.default.createElement('img', { src: _home.shapes, className: 'shapes-image feature-illu', alt: 'Shapes example' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-6 text-content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'feature-icon margin-s-bottom' },
	              _react2.default.createElement('img', { src: _home.shapeIcon, alt: 'Shapes illustration' })
	            ),
	            _react2.default.createElement(
	              'h2',
	              { className: 'light' },
	              'Use your own custom shapes'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'light' },
	              'Keep generating to find the perfect compostion of your shapes.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'grid yg depth-feature padding-xxl center text-center' },
	          _react2.default.createElement('div', { className: 'blur-bg' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'content margin-xxl-bottom' },
	              _react2.default.createElement(
	                'div',
	                { className: 'feature-icon margin-s-bottom' },
	                _react2.default.createElement('img', { src: _home.depth, alt: 'Depth illustration' })
	              ),
	              _react2.default.createElement(
	                'h2',
	                { className: 'light' },
	                'Depth of Field'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'light narrow' },
	                'Love to work with parallax and have a depth of field? Look no further as we added the feature to mimic the blur of camera depth of field.'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'grid yg symbol-feature padding-xxl align-middle' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-6' },
	            _react2.default.createElement('img', { src: _home.symbolOverview, className: 'symbol-image feature-illu', alt: 'Symbol example' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-6 text-content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'feature-icon margin-s-bottom' },
	              _react2.default.createElement('img', { src: _home.symbol, alt: 'Symbol illustration' })
	            ),
	            _react2.default.createElement(
	              'h2',
	              { className: 'light' },
	              'Symbol all the things!'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'light' },
	              'Use symbols to easily make changes to the look of your confetti.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'grid yg padding-xxl cta-row center text-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12' },
	            _react2.default.createElement(
	              'p',
	              { className: 'light streamer margin-l-bottom' },
	              'Generate gorgeous confetti patterns in 1 click within Adobe XD.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'cta' },
	              _react2.default.createElement(
	                _gatsbyPluginGoogleAnalytics.OutboundLink,
	                {
	                  className: 'btn primary lg',
	                  href: 'https://xd.adobelanding.com/en/xd-plugin-download/?name=d2f4d13f'
	                },
	                _react2.default.createElement(
	                  'svg',
	                  { width: '32', height: '32', viewBox: '0 0 32 32' },
	                  _react2.default.createElement(
	                    'g',
	                    { fill: 'none', fillRule: 'evenodd' },
	                    _react2.default.createElement('circle', { cx: '16', cy: '16', r: '16', fill: '#FFFFFF', fillRule: 'nonzero' }),
	                    _react2.default.createElement('path', { fill: '#FF007E', fillRule: 'nonzero', d: 'M14.4746456,18.3952784 L14.4746456,10.032875 C14.4746456,9.1862915 15.1609371,8.5 16.0075206,8.5 C16.8541041,8.5 17.5403956,9.1862915 17.5403956,10.032875 L17.5403956,18.3802372 L19.429711,16.4909218 C20.0154974,15.9051354 20.9652449,15.9051354 21.5510313,16.4909218 C22.1368178,17.0767083 22.1368178,18.0264557 21.5510313,18.6122422 L17.1689139,22.9943595 C17.1020392,23.0612343 17.0304209,23.1204745 16.9551422,23.1720801 C16.6943434,23.3774655 16.3652417,23.5 16.0075206,23.5 C15.6899075,23.5 15.3948559,23.4034025 15.150142,23.2379836 C15.035958,23.172972 14.9284904,23.0917639 14.8310861,22.9943595 L10.4489687,18.6122422 C9.86318225,18.0264557 9.86318225,17.0767083 10.4489687,16.4909218 C11.0347551,15.9051354 11.9845026,15.9051354 12.570289,16.4909218 L14.4746456,18.3952784 Z' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'Install Now',
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'v3.0.2'
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-d9ac27f61d0f7282047e.js